import { render, staticRenderFns } from "./carBoard.vue?vue&type=template&id=b0cc9caa&scoped=true&"
import script from "./carBoard.vue?vue&type=script&lang=js&"
export * from "./carBoard.vue?vue&type=script&lang=js&"
import style0 from "./carBoard.vue?vue&type=style&index=0&id=b0cc9caa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cc9caa",
  null
  
)

export default component.exports